import { render, staticRenderFns } from "./TyreListItem.vue?vue&type=template&id=ea8bb9e8"
import script from "./TyreListItem.vue?vue&type=script&lang=js"
export * from "./TyreListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports